/* Component: autoship-calculator
   Drives the ih-lp-autoship-calculator section's live basket-size slider.
   A single instance wraps both the desktop and mobile markup branches, so
   dragging either range input keeps both branches' output in sync regardless
   of which one is currently visible at the viewport's breakpoint. */
if (!customElements.get('autoship-calculator')) {
  class AutoshipCalculator extends HTMLElement {
    constructor() {
      super();
      this.min = 25;
      this.max = 150;
      this.discount = 0.20;
      this.orders = 7;
      this.ranges = this.querySelectorAll('[data-ac-range]');
      this.ranges.forEach((range) => {
        range.addEventListener('input', (e) => this.update(+e.target.value));
      });
      this.update(70);
    }

    money(n) {
      return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    update(basket) {
      const oneTime = basket * this.orders;
      const autoship = basket * (1 - this.discount) * this.orders;
      const savings = oneTime - autoship;
      const fillPct = ((basket - this.min) / (this.max - this.min)) * 100;

      this.ranges.forEach((range) => {
        range.value = basket;
        range.setAttribute('aria-valuenow', basket);
      });
      this.querySelectorAll('[data-ac-basket]').forEach((el) => { el.textContent = '$' + basket; });
      this.querySelectorAll('[data-ac-fill]').forEach((el) => { el.style.width = fillPct + '%'; });
      this.querySelectorAll('[data-ac-onetime]').forEach((el) => { el.textContent = this.money(oneTime); });
      this.querySelectorAll('[data-ac-autoship]').forEach((el) => { el.textContent = this.money(autoship); });
      this.querySelectorAll('[data-ac-savings]').forEach((el) => { el.textContent = this.money(savings); });
    }
  }

  customElements.define('autoship-calculator', AutoshipCalculator);
}
